import { render } from "./MobileGreenBox4.vue?vue&type=template&id=0e20d474"
import script from "./MobileGreenBox4.vue?vue&type=script&lang=js"
export * from "./MobileGreenBox4.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tre/tre/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__